export const pasteFromClipboard = async (setter) => {
  setter({ error: '' });
  if (!navigator.clipboard?.readText) {
    setter({
      error:
        'Clipboard API not available. Use HTTPS/localhost or press Ctrl/⌘+V.',
    });
    return;
  }
  try {
    setter({ busy: true });
    const text = await navigator.clipboard.readText();
    setter({ value: text });
  } catch (e) {
    setter({ error: 'Could not read clipboard: ' + (e?.message || e) });
  } finally {
    setter({ busy: false });
  }
};
